import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  DepartmentResponse,
  DepartmentItem,
  AddDepartmentResponse,
  DepartmentCommonResponse,
} from '@core/interface/department';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  constructor(private http: HttpClient) {}

  getDepartments(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<DepartmentResponse>(
      environment.endPoints.departmentList,
      {
        params: httpParams,
      }
    );
  }
  addDepartment(data: DepartmentItem) {
    return this.http.post<AddDepartmentResponse>(
      environment.endPoints.departmentAddEdit,
      data
    );
  }
  deleteDepartment(id: number) {
    return this.http.get<DepartmentCommonResponse>(
      environment.endPoints.departmentDelete(id),
      { observe: 'response' }
    );
  }
}
